import React from 'react';
import { useTranslation } from 'react-i18next';
import { Door } from '@/components/Icons/Door';
import { Shuffle } from '@/components/Icons/Shuffle';
import { EMPTY_LESSON_SUBJECT, type DiaryLesson } from '@/types/diary';

interface Props {
  lesson: DiaryLesson;
}

export const DiaryLessonCell: React.FC<Props> = ({ lesson }) => {
  const { t } = useTranslation();
  const isEmptyLesson = lesson.className === EMPTY_LESSON_SUBJECT;
  const subjectClassName = isEmptyLesson
    ? 'text-subtle-foreground'
    : 'text-foreground';

  return (
    <div className="flex flex-1 items-center gap-4 py-2 pr-3 pl-5">
      <div className="flex min-w-0 flex-1 flex-col">
        <span className={`text-subhead-14 ${subjectClassName}`}>
          {isEmptyLesson ? t('diary.emptyLesson') : lesson.className}
        </span>
        {!!lesson.roomNumber && (
          <span className="mt-1 flex items-center gap-1 text-body-14 text-subtle-foreground">
            <Door className="size-4 shrink-0" />
            {lesson.roomNumber}
          </span>
        )}
      </div>
      {lesson.isOnlyForCurrentWeek && (
        <Shuffle className="size-4 shrink-0 text-accent" />
      )}
    </div>
  );
};
